import Vue from 'vue'

import jquery from 'jquery/dist/jquery.js'
window.JQuery = jquery
window.$ = jquery

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap-vue/dist/bootstrap-vue.min.js'


Vue.use(BootstrapVue)